module.exports = __webpack_public_path__ + "static/media/habbit-backend.721ad2ab.png";